import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "noprint" }

import { onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'

import NotificationBanner from '@/components/common/NotificationBanner.vue'
import LeagueBreadcrumbs from '@/components/widgets/public/LeagueBreadcrumbs.vue'
import { useLeaguesStore } from '@/store/public/leagues'
import { getErrorMessage } from '@/utils/error-handling'


export default /*@__PURE__*/_defineComponent({
  __name: 'LeagueView',
  setup(__props) {

const leagues = useLeaguesStore()
const route = useRoute()

const errorMessage = ref<string | null>(null)
const isLoading = ref<boolean>(true)

async function onRouteChange() {
  errorMessage.value = null
  isLoading.value = true

  const season = (route.params.season as string) ?? null
  const leagueId = (route.params.id as string) ?? null

  try {
    leagues.selectSeason(season)
    await leagues.selectLeagueById(leagueId)
  } catch (e) {
    const message = getErrorMessage(e as Error)
    console.error(`Failed selecting season or league: ${message}`)
    errorMessage.value = message
  }

  isLoading.value = false
}

watch(() => route.path, onRouteChange)

onMounted(async () => {
  await onRouteChange()
})

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("main", null, [
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t('leagues.view-title')), 1),
          _createVNode(LeagueBreadcrumbs),
          _createVNode(_component_RouterView)
        ], 64))
      : (errorMessage.value)
        ? (_openBlock(), _createBlock(NotificationBanner, {
            key: 1,
            message: errorMessage.value,
            "is-danger": ""
          }, null, 8, ["message"]))
        : _createCommentVNode("", true)
  ]))
}
}

})